import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M5 19h1.4l8.625-8.625-1.4-1.4L5 17.6zM19.3 8.925l-4.25-4.2 1.4-1.4a1.92 1.92 0 0 1 1.413-.575q.839 0 1.412.575l1.4 1.4q.574.575.6 1.388a1.8 1.8 0 0 1-.55 1.387zM4 21a.97.97 0 0 1-.713-.288A.96.96 0 0 1 3 20v-2.825q0-.2.075-.388a1 1 0 0 1 .225-.337l10.3-10.3 4.25 4.25-10.3 10.3a1 1 0 0 1-.725.3zM14.325 9.675l-.7-.7 1.4 1.4z"
    }, null, -1)
  ]))]))
}
export default { render: render }